<template>
  <div class="i-select">
    <div class="i-select-input-wrapper">
      <input
        ref="input"
        type="text"
        class="i-select-input"
        :placeholder="placeholder"
        :value="value"
        @focus="onFucus"
        @blur="onBlur"
        @input="onInput"
        @keyup.enter="onSubmit"
      >
      <div
        class="icon"
        @click="onIconClick"
      >
        <slot name="icon" />
      </div>
      <div class="i-select-mask">
        {{ $t(value || 'all') }}
      </div>
    </div>
    <ul
      v-show="isOptionsShow"
      class="i-select-options"
    >
      <li
        v-for="(option, index) in options"
        :key="index"
        v-tooltip="tooltipOptions($t(getOptionText(option)))"
        class="i-select-option"
        @mousedown="onSelect(option)"
      >
        {{ $t(getOptionText(option) || 'all') }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'ISelect',
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    fallbackValue: {
      type: [String, null],
      default: ''
    },
    options: {
      type: Array,
      default () {
        return []
      }
    },
    optionFormat: {
      type: Object,
      default: null
    },
    iconBehavior: {
      type: String,
      default: 'focus'
    },
    cleanOnFoucus: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isOptionsShow: false
    }
  },
  computed: {
  },
  methods: {
    tooltipOptions (content) {
      return {
        placement: 'top-start',
        content,
        boundary: document.body,
        delay: {
          show: 200
        }
      }
    },
    getOptionText (option) {
      return this.optionFormat ? option[this.optionFormat.textKey] : option
    },
    getOptionValue (option) {
      return this.optionFormat ? option[this.optionFormat.valueKey] : option
    },
    onFucus () {
      this.isOptionsShow = true
    },
    onBlur () {
      if (this.fallbackValue != null && this.value === '') {
        this.$emit('input', this.fallbackValue)
      }
      this.isOptionsShow = false
    },
    onInput (e) {
      // if (e.target.value === '' && this.fallbackValue != null) this.$emit('input', this.fallbackValue)
      // else this.$emit('input', e.target.value)
      this.$emit('input', e.target.value)
    },
    onSubmit () {
      this.$emit('submit', this.value)
    },
    onSelect (option) {
      this.$emit('select', option)
      this.$emit('input', this.getOptionValue(option))
    },
    onIconClick () {
      if (this.iconBehavior === 'focus') {
        this.$refs.input.focus()
        this.onFucus()
      }
      if (this.iconBehavior === 'submit') this.onSubmit()
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~css/common/extends'
@import '~css/addon/main'

$input-height = 46px
.i-select {
  position: relative;
  display: flex;
  width: 100%

  .i-select-input-wrapper {
    position: relative
    width: 100%
    height $input-height
    display: flex
    border-radius: 10px;
    background-color: #fff
    box-shadow: 1px 1px 2px rgba(0,0,0,0.3)
    padding: 0 20px;

    .i-select-input {
      position: relative
      width: 100%;
      height: $input-height;
      line-height $input-height;
      font-size 16px;
      outline: none;
      border: none
      color: #212121;
      transition: 0.3s;
      background-color: transparent;
    }

    .i-select-mask {
      position: absolute
      width: calc(100% - 40px - 32px);
      height: 100%;
      left: 20px;
      top: 0;
      background-color: #fff;
      color: #000;
      display: flex;
      align-items: center;
    }
  }

  .i-select-submit {
    padding-right: 5px
    width: 50px
    height: $input-height
    text-align: center
    color: #fff
    font-size: 20px
    background: $white
    border: 1px solid $white
    border-radius: 0 15px 15px 0
    cursor: pointer
  }

  .i-select-options {
    z-index: 1
    position: absolute
    top: $input-height + 10px
    padding: 12px 10px
    width: 100%
    min-width: 320px
    max-height: 324px
    background-color #fff
    box-shadow: 1px 1px 2px rgba(0,0,0,0.3)
    border-radius: 10px
    overflow: auto
    color: #222

    .i-select-option {
      width: 100%
      padding 0 10px
      line-height: 28px
      position relative
      white-space nowrap
      text-overflow ellipsis
      overflow hidden

      &:hover {
        cursor: pointer
        background-color: #E5E5E5
      }
    }
  }
  .icon {
    cursor: pointer
  }
}
</style>
